import { useState ,useEffect} from "react";
import {
  Box,
  Tabs,
  Tab,
  Typography,
  TextField,
  Button,
  Card,
  CardContent,
} from "@mui/material";
import Sidebar from "../../Drawer/Sidebar";
import { useNavigate } from "react-router-dom";
import { canShowPermission } from "../Permissions/permissionObject";

export default function ProductList() {
  const navigate = useNavigate();
  const [tabIndex, setTabIndex] = useState(0);
  const [onlineTC, setOnlineTC] = useState("");
  const [offlineTC, setOfflineTC] = useState("");
  const [category, setCategory] = useState("");
  const [categories, setCategories] = useState([]);

    const [permissions, setPermissions] = useState({});

useEffect(() => {
  const storedPermissions = localStorage.getItem("userPermissions");
  if (storedPermissions) {
    try {
      setPermissions(JSON.parse(storedPermissions));
    } catch (e) {
      console.error("Invalid permissions JSON", e);
    }
  }
}, []);

const canCreateProduct = canShowPermission(permissions, "products", "create");

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };
  const handleAddCategory = () => {
    if (category.trim()) {
      setCategories([...categories, category.trim()]);
      setCategory("");
    }
  };


  return (
        <Box sx={{ width: "100%", height: "100vh",overflow:'auto' }}>
        <Box  sx={{
          width: "1143px",
          mt: { xs: 10, md: 10 },
          background: "#fff",
          borderRadius: "16px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}>

        <CardContent>
          <Typography
            fontWeight={700}
            fontSize={24}
            mb={3}
            fontFamily={"Aeonik"}
          >
            Product List
          </Typography>
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            sx={{ borderBottom: 1, borderColor: "divider" }}
          >
            <Tab
              label="Product List"
              id="tab-0"
              aria-controls="tabpanel-0"
              fontFamily={"Inter"}
              sx={{
                textTransform: "none",
                fontWeight: "600",
                fontSize: "18px",
                color: "#888",
                "&.Mui-selected": {
                  color: "#752ADA",
                  fontWeight: "600",
                },
              }}
            />
            <Tab
              label="Product Category"
              id="tab-1"
              aria-controls="tabpanel-1"
              fontFamily={"Inter"}
              sx={{
                fontWeight: "600",
                textTransform: "none",
                fontSize: "18px",
                color: "#888",
                "&.Mui-selected": {
                  color: "#752ADA",
                  fontWeight: "600",
                },
              }}
            />
          </Tabs>
          {/* Tab Panel 1: Product List */}
          {tabIndex === 0 && (
            <Box role="tabpanel" id="tabpanel-0" aria-labelledby="tab-0" mt={3}>
              <Box display="flex" justifyContent="flex-end" mb={2}>
                {/* New Product button*/}
              {canCreateProduct && ( <Button
                  variant="contained"
                  sx={{
                    background: "#7028DA",
                    textTransform: "none",
                    fontSize: "16px",
                  }}
                  fontFamily={"Inter"}
                  onClick={() => navigate("/CreateProduct")}
                >
                  + New Product
                </Button>)} 
              </Box>
              <Box display="flex" gap={3} flexWrap="wrap">
                <Box flex={1}>
                  <Typography
                    variant="body2"
                    mb={1}
                    fontWeight={500}
                    fontFamily={"Inter"}
                    fontSize={14}
                    color="#606778"
                  >
                    Online T & C
                  </Typography>
                  {/* Write terms and condition textfield */}
                  <TextField
                    multiline
                    rows={4}
                    fullWidth
                    placeholder="Write terms and conditions"
                    value={onlineTC}
                    onChange={(e) => setOnlineTC(e.target.value)}
                  />
                </Box>
                <Box flex={1}>
                  <Typography
                    variant="body2"
                    mb={1}
                    fontWeight={500}
                    fontFamily={"Inter"}
                    fontSize={14}
                    color="#606778"
                  >
                    Offline T & C
                  </Typography>
                  {/* Write terms and condition textfield */}
                  <TextField
                    multiline
                    rows={4}
                    fullWidth
                    placeholder="Write terms and conditions"
                    value={offlineTC}
                    onChange={(e) => setOfflineTC(e.target.value)}
                  />
                </Box>
              </Box>
              <Box display="flex" justifyContent="flex-end" mt={3}>
                {/* Save button */}
              {canCreateProduct && (<Button
                  variant="contained"
                  sx={{
                    bgcolor: "#7028DA",
                    textTransform: "none",
                    px: 4,
                    fontSize: "16px",
                  }}
                  fontFamily={"Inter"}
                >
                  Save
                </Button>)}  
              </Box>
            </Box>
          )}
          {/* Tab Panel 2: Product Category */}
          {tabIndex === 1 && (
            <Box role="tabpanel" id="tabpanel-1" aria-labelledby="tab-1" mt={3}>
              <Typography variant="body2" mb={2}>
                Product Categories
              </Typography>

              <Box display="flex" gap={2} mb={2}>
                <TextField
                  label="New Category"
                  variant="outlined"
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                  fullWidth
                />
              {canCreateProduct && (<Button
                  variant="contained"
                  sx={{
                    bgcolor: "#7028DA",
                    textTransform: "none",
                    px: 4,
                    fontSize: "16px",
                  }}
                  fontFamily={"Inter"}
                  onClick={handleAddCategory}
                >
                  Add
                </Button>)}  
              </Box>
              <Typography variant="subtitle2">Existing Categories:</Typography>
              {categories.length === 0 ? (
                <Typography variant="body2" color="text.secondary">
                  No categories added yet.
                </Typography>
              ) : (
                <ul>
                  {categories.map((cat, index) => (
                    <li key={index}>{cat}</li>
                  ))}
                </ul>
              )}
            </Box>
          )}
        </CardContent>
 
    </Box>
    </Box>
  );
}
